import { Location } from '@trnsact/trnsact-shared-types';
import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import { Column } from 'react-table';

export function createTableColumns(): Column<Location>[] {
  return [
    {
      Header: 'Name',
      accessor: 'locationName',
      Cell: ({ original }: { original: Location }) => <SimpleTextCell value={original.locationName} />,
    },
    {
      Header: 'Type',
      accessor: 'category',
      Cell: ({ original }: { original: Location }) => <SimpleTextCell value={original.category} />,
    },
    {
      Header: 'Primary Contact',
      accessor: 'ocaContact[fullName]',
      Cell: ({ original }: { original: Location }) => <SimpleTextCell value={original.ocaContact?.fullName} />,
    },
    {
      Header: 'Parent Location',
      accessor: 'locationParentName',
      Cell: ({ original }: { original: Location }) => <SimpleTextCell value={original.locationParentName} />,
    },
    {
      Header: 'Child Location',
      accessor: 'childrenLocation',
      Cell: ({ original }: { original: Location }) => {
        return (
          original.childrenLocation
            ?.map(l => <SimpleTextCell key={l!.locationId} value={l!.locationName} />)
            .join('\n') ?? <SimpleTextCell value={null} />
        );
      },
    },
  ].map(header => ({
    ...header,
    resizable: false,
    headerClassName: 'customHeader',
  }));
}
